/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Portfolio_Page_Meta_TitleInputs */

const en_create_portfolio_page_meta_title = /** @type {(inputs: Create_Portfolio_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create portfolio | Glider`)
};

const de_create_portfolio_page_meta_title = /** @type {(inputs: Create_Portfolio_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfolio erstellen | Glider`)
};

const pt_br2_create_portfolio_page_meta_title = /** @type {(inputs: Create_Portfolio_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar portfólio | Glider`)
};

const tr_create_portfolio_page_meta_title = /** @type {(inputs: Create_Portfolio_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portföy oluştur | Glider`)
};

const zh_cn2_create_portfolio_page_meta_title = /** @type {(inputs: Create_Portfolio_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建投资组合 | Glider`)
};

const zh_hk2_create_portfolio_page_meta_title = /** @type {(inputs: Create_Portfolio_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立投資組合 | Glider`)
};

const ko_kr2_create_portfolio_page_meta_title = /** @type {(inputs: Create_Portfolio_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포트폴리오 만들기 | Glider`)
};

const ru_ru2_create_portfolio_page_meta_title = /** @type {(inputs: Create_Portfolio_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать портфель | Glider`)
};

const es_419_create_portfolio_page_meta_title = /** @type {(inputs: Create_Portfolio_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear portafolio | Glider`)
};

/**
* | output |
* | --- |
* | "Create portfolio \| Glider" |
*
* @param {Create_Portfolio_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const create_portfolio_page_meta_title = /** @type {((inputs?: Create_Portfolio_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Portfolio_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_portfolio_page_meta_title(inputs)
	if (locale === "de") return de_create_portfolio_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_create_portfolio_page_meta_title(inputs)
	if (locale === "tr") return tr_create_portfolio_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_create_portfolio_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_create_portfolio_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_create_portfolio_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_create_portfolio_page_meta_title(inputs)
	return es_419_create_portfolio_page_meta_title(inputs)
});